import david from '../assets/png/david_grayscale_5.png'
import man from '../assets/png/man.png'
import path from '../assets/png/path.png'

export const headerData = {
    name:'David Delannoy',
    target:'Pour les entreprises et les particuliers',
    prefix: ">home/:~$ ",
    title: "Développeur",
    title1: "Consultant technique",
    title2: "Consultant technico-fonctionnel",
    title3: "Consultant technico-fonctionnel",
    description:"Concevoir et développer des applications informatiques ergonomiques, maintenables, évolutives et conformes aux besoins exprimés. Transmettre la capacité et le plaisir d’apprendre.", 
    image: david,
    image2:man,
    illustration: path,
    resumePdf: `${process.env.PUBLIC_URL}/CV_daviddelannoy.html`
}
